/* =========================================================
   customer-number.js — Formular "Kundennummer sichern"
   ---------------------------------------------------------
   07.10.2026. Zwei Modi, automatisch gewählt:
   - data-cn-endpoint gesetzt (Cloudflare-Worker-URL): Daten
     gehen per fetch an den Worker, der Kunde wird in Shopify
     angelegt, die Kundennummer kommt zurück und wird gezeigt.
   - kein Endpoint: Das Formular wird als normales Shopify-
     Kontaktformular verschickt (E-Mail an den Shop), Luisa
     legt den Kunden dann von Hand an.
   ========================================================= */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('CnForm');
    if (!form) return;

    var endpoint = form.getAttribute('data-cn-endpoint') || '';
    var result = document.querySelector('[data-cn-result]');
    var btn = form.querySelector('[data-cn-submit]');
    var addrBox = form.querySelector('[data-cn-address]');
    var shipNote = form.querySelector('[data-cn-ship-note]');
    var pickNote = form.querySelector('[data-cn-pick-note]');
    var radios = form.querySelectorAll('input[name="cn_delivery"]');
    var addrInputs = addrBox ? addrBox.querySelectorAll('[data-cn-req]') : [];

    function field(name) {
      var el = form.querySelector('[data-cn="' + name + '"]');
      return el ? el.value.trim() : '';
    }

    function method() {
      var r = form.querySelector('input[name="cn_delivery"]:checked');
      return r ? r.value : '';
    }

    function sync() {
      var m = method();
      var delivery = m === 'lieferung';
      if (shipNote) shipNote.hidden = !delivery;
      if (pickNote) pickNote.hidden = m !== 'abholung';
      Array.prototype.forEach.call(addrInputs, function (i) { i.required = delivery; });
    }

    Array.prototype.forEach.call(radios, function (r) { r.addEventListener('change', sync); });
    sync();

    function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }

    function showError(msg) {
      clear(result);
      var p = document.createElement('p');
      p.className = 'cn__error';
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      result.appendChild(p);
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function showSuccess(number, emailSent) {
      clear(result);
      var box = document.createElement('div');
      box.className = 'cn__success';

      var label = document.createElement('p');
      label.className = 'cn__success-label';
      label.textContent = 'Geschafft! Deine Kundennummer lautet:';

      var num = document.createElement('p');
      num.className = 'cn__number';
      num.textContent = number;

      var text = document.createElement('p');
      text.className = 'cn__success-text';
      text.textContent = emailSent
        ? 'Wir haben sie dir zusätzlich per E-Mail geschickt. Schreib sie im nächsten Live einfach in die Kommentare, wenn dir ein Teil gefiel.'
        : 'Bitte notiere sie dir. Schreib sie im nächsten Live einfach in die Kommentare, wenn dir ein Teil gefällt.';

      box.appendChild(label);
      box.appendChild(num);
      box.appendChild(text);
      result.appendChild(box);
      form.hidden = true;
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('submit', function (e) {
      var payload = {
        firstName: field('first_name'),
        lastName: field('last_name'),
        email: field('email'),
        instagram: field('instagram'),
        delivery: method(),
        street: field('street'),
        zip: field('zip'),
        city: field('city'),
        country: field('country'),
        consent: !!form.querySelector('[data-cn="consent"]:checked'),
        website: field('website')
      };

      if (!endpoint) {
        var hiddenName = form.querySelector('[data-cn-hidden-name]');
        var hiddenBody = form.querySelector('[data-cn-hidden-body]');
        if (hiddenName) hiddenName.value = payload.firstName + ' ' + payload.lastName;
        if (hiddenBody) {
          hiddenBody.value =
            'Neue Anfrage für Live-Shopping-Kundennummer\n\n' +
            'Name: ' + payload.firstName + ' ' + payload.lastName + '\n' +
            'E-Mail: ' + payload.email + '\n' +
            'Instagram-Name: ' + payload.instagram + '\n' +
            'Versandart: ' + (payload.delivery === 'lieferung' ? 'Lieferung (Versand wird extra berechnet)' : 'Abholung im Laden') + '\n' +
            'Adresse: ' + [payload.street, payload.zip + ' ' + payload.city, payload.country].join(', ');
        }
        return;
      }

      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }

      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Wird gesendet…';
      clear(result);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (r.ok && r.data.success) {
            showSuccess(r.data.kundennummer, !!r.data.emailSent);
          } else {
            showError(r.data.error || 'Etwas ist schiefgelaufen. Bitte versuche es erneut.');
            btn.disabled = false;
            btn.textContent = original;
          }
        })
        .catch(function () {
          showError('Verbindung fehlgeschlagen. Bitte versuche es erneut.');
          btn.disabled = false;
          btn.textContent = original;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
